module.exports = __webpack_public_path__ + "images/Rectangle.png";